module.exports = __webpack_public_path__ + "img/emp2-1.59f5cc9f.jpg";